
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1.667A3.333 3.333 0 0113.333 5v1.575h.834a2.5 2.5 0 012.5 2.5v6.667a2.5 2.5 0 01-2.5 2.5H5.833a2.5 2.5 0 01-2.5-2.5V9.075a2.5 2.5 0 012.5-2.5h.834V5A3.333 3.333 0 0110 1.667zm4.167 6.575H5.833A.833.833 0 005 9.075v6.667c0 .46.373.833.833.833h8.334c.46 0 .833-.373.833-.833V9.075a.833.833 0 00-.833-.833zM10 10a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1.667a.833.833 0 100 1.666.833.833 0 000-1.666zm0-8.425A1.717 1.717 0 008.333 5v1.575h3.334V5A1.717 1.717 0 0010 3.242z"}})])
          )
        }
      }
    